import React, { Component } from "react";
import moment from "moment";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import routes from "./routes/URL";
import LocationPopup from "./components/LocationPopup";
import redux from "./common/Redux";
import String from "./common/Strings";
import API, { URL_PATH } from "./services/API";
import { AuthRoutes, AdminRoutes, SubscriptionRoutes } from "./routes";
import { HotelRoutes } from "./routes";
import Colors from "./common/Colors";
import LanguageSelection from "./components/LanguageSelection";
import { CreateHotelScreen, SelectHotelScreen } from "./screens";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationPopupShown: false,
    };
    this.fetchStrings();

    console.log("Navigation-------------------------------------");
  }
  fetchStrings = async () => {
    const result = await API(this, "get", URL_PATH.getStrings);
  };
  checkLogin = async () => {
    const result = await API(this, "get", URL_PATH.ping);
    const { status, message, data } = result;

    console.log("resultresultresult",result)
    if (status == "success") {
      const { accessControls, isAuth, subscription_active } = data;
      this.props.setAuth(true);
      this.props.setAccessControl(accessControls);
      this.props.setSubscriptionActive(subscription_active);
      // this.props.setUser(data);
      // if (!subscription_active.status) {
      //   alert(subscription_active.message || "Your subscription is not active.");
      // }
    } else {
      this.props.setAuth(false);
    }
    // this.pingCall = setInterval(() => this.ping(), 5000);
  };

  ping = async () => {
    const result = await API(this, "get", URL_PATH.ping, {}, {}, false);
    const { status, message, accessControls, isAuth } = result;
    if (status == "error") return this.props.setAuth(false);
    this.props.setAccessControl(accessControls);
  };

  componentDidMount() {
    this.checkLogin();
  }

  componentWillUnmount() {
    clearInterval(this.pingCall);
  }

  RootNavigation = () => {
    // console.log("SubscriptionActive: ", this.props.subscriptionActive);

    return (
      <div
        style={{
          backgroundColor: Colors.rootBgColor,
          minHeight: "100%",
        }}
      >
        <Switch>
          <Route path={routes.auth.login} component={AuthRoutes} />
          {/* <Route
            path={routes.admin.subscription.root}
            component={SubscriptionRoutes}
          /> */}

          {this.props.isAuth && (
            <Route
              path={routes.admin.hotels.create}
              component={CreateHotelScreen}
            />
          )}

          <Route
            path={routes.root}
            component={
              // TestPusher
              this.props.isAuth
                ? this.props.subscriptionActive
                  ? this.props.selectedHotelId
                    ? AdminRoutes
                    : SelectHotelScreen
                  : SubscriptionRoutes
                : AuthRoutes
            }
          />
        </Switch>
      </div>
    );
  };
  render() {
    const { locationPopupShown } = this.state;
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/">
            <this.RootNavigation />
          </Route>
        </Switch>
        {locationPopupShown && <LocationPopup />}
        {/* <LanguageSelection /> */}
        {/* loader */}
        {this.props.loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: 15,
                // backgroundColor: "rgba(0,0,0,0.5)",
                // backgroundColor: Colors.pageBgColor,
                alignSelf: "center",
                borderRadius: "50%",
              }}
            >
              <img
                src={"/Etable Loading.gif"}
                style={{
                 width:180      ,           
                  height:180,
                  // borderRadius: "70px",
                }}
                className="fade-in"
              />
            </div>
          </div>
        )}
      </BrowserRouter>
    );
  }
}

export default redux(Navigation);
